/**
 * Toolbar search: SearchInput's toggle collapses it to an icon below `@4xl` of
 * CandidatesToolbar's row; expanded, it takes over the stage tabs area.
 */

import React from 'react';
import { SearchInput } from '@/components/ui/search-input';
import { cn } from '@/utils/cn';

export interface CandidatesToolbarSearchProps {
  value: string;
  onChange: (value: string) => void;
  onDebouncedChange?: (value: string) => void;
  placeholder?: string;
  isExpanded: boolean;
  onExpandedChange: (isExpanded: boolean) => void;
}

export const CandidatesToolbarSearch: React.FC<CandidatesToolbarSearchProps> = ({
  value,
  onChange,
  onDebouncedChange,
  placeholder,
  isExpanded,
  onExpandedChange,
}) => (
  <SearchInput
    value={value}
    onChange={onChange}
    onDebouncedChange={onDebouncedChange}
    placeholder={placeholder}
    showClearButton
    size="md"
    responsive={false}
    mobileToggle
    toggleAt="@4xl"
    expanded={isExpanded}
    onExpandedChange={onExpandedChange}
    className={cn('w-56 min-w-32', isExpanded && '@max-4xl:w-auto @max-4xl:flex-1')}
  />
);
